import { useState, useEffect } from "react";
// import Breadcrumbs from "./BreadCrumbs";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  fcheck_null_undefine_replace_empty,
  getStatusStyle,
  getStatusStyleV1,
  getUniqueValues,
} from "../../Utility/Utilitys";
import { ISTCRA_Summary, RSPCRA_SummaryApi } from "../../Server/ApiV2";
import { useNavigate } from "react-router-dom";
import { createMultiSelectOperator } from "../../Component/Common/ReuseableComponent/DatagridFilterColumnComp";
import { Head_Set } from "./SliceRSPChangeRequest";
import RSPChange_Breadcrumbs from "./RSPChange_Breadcrumbs";
import GCAutocompleteCheckboxFixSizeUid from "./proccessComponent/GCAutocompleteCheckboxFixSizeUid";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

const statusOptions = ["All", "Enter", "Post"];

export default function RSPChangeSummary() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const vRdxUserInfoObj = vRdxUserInfo();

  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const vRdxHead = useSelector(
    (state) => state.SliceStockSetupChangeRequest.value.Head
  );

  const [filterObj, setFilterObj] = useState({
    dateFrom: moment().startOf("month").toDate(),
    dateTo: moment().toDate(),
    location: vRdxuserLoc?.map((item) => item.Uid),
    status: "All",
  });

  const [row, setRow] = useState([]);
  const multiSelectMUIlocation = getUniqueValues(row, "Loc_Name");

  const fonLoad = async (  ) => {
          const locationStr = Array.isArray(filterObj?.location)
        ? filterObj?.location.join(",")
        : filterObj?.location || "";
    var obj = {
      FromDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
      ToDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"),
      Location: locationStr,
      Status: filterObj?.status || "",
      UserCd: vRdxUserInfoObj?.UserID,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const sumFilterRes = await RSPCRA_SummaryApi(FinalObj);
    if (sumFilterRes?.status === 200) {
      setRow(sumFilterRes?.data?.recordset);
    } else {
      setRow([]);
    }
  };

  const handleRowClick = (params) => {
    dispatch(
      Head_Set({
        ...vRdxHead,
        A_TransId: params.row?.A_TransId,
        A_Date: params.row?.A_Date,
        A_Loc: params.row?.A_Loc,
        Loc_Name: params.row?.Loc_Name,
        A_Narration: params.row?.A_Narration,
        A_Status: params.row?.A_Status,
        CreatedBy: params.row?.CreatedBy,
        CreatedDate: params.row?.CreatedDate,
        ApproveStatus: params.row?.ApproveStatus,
        ApprovedBy: params.row?.ApprovedBy,
        ApproveDt: params.row?.ApproveDt,
        A_CM_Dt: params.row?.A_CM_Dt,
        A_CM_By: params.row?.A_CM_By,
        A_StatusCM: params.row?.A_StatusCM,
        A_PM_By: params.row?.A_PM_By,
        A_PM_Dt: params.row?.A_PM_Dt,
        A_StatusPM: params.row?.A_StatusPM,
        A_LocCSV: params.row?.A_LocCSV,
        LoccsvName: params.row?.LoccsvName,
      })
    );
    navigate("/RSPChangeRequestDetail");
  };

   const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true
  });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };


  return (
    <>
          <Box sx={{ mt: { xs: 2, md: 0 } }}>
          <RSPChange_Breadcrumbs />
          </Box>
        <Grid
          container
        spacing={{ xs: 1.5, md: 1 }}
        sx={{ alignItems: { xs: "flex-end" }, mt: { xs: 1, sm: 0 } }}
        >
          <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
            <Typography>From Date</Typography>
            <CmpDatePickerField001V1
              xLabelText=""
              xName={"dateFrom"}
              xValue={filterObj?.dateFrom}
              xOnChange={(newValue) => {
                setFilterObj((prev) => ({
                  ...prev,
                  dateFrom: newValue?.$d ?? newValue,
                }));
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
            <Typography>To Date</Typography>
            <CmpDatePickerField001V1
              xLabelText=""
              xName={"dateTo"}
              xValue={filterObj?.dateTo}
              xOnChange={(newValue) => {
                //
                setFilterObj((prev) => ({
                  ...prev,
                  dateTo: newValue?.$d ?? newValue,
                }));
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4.5} lg={4}>
            <Typography>Location</Typography>
            <GCAutocompleteCheckboxFixSizeUid
              options={vRdxuserLoc ?? []}
              xValue={filterObj?.location}
              setValue={(updatedObj) => {
                setFilterObj((prev) => ({
                  ...prev,
                  location: updatedObj,
                }));
              }}
              objName="location"
              label=""
              placeholder="Search Location"
            />
          </Grid>
          <Grid item xs={12} sm={3} md={2.5} lg={1.5}>
            <Typography>Status</Typography>
            <FormControl fullWidth>
              <Select
                size="small"
                value={filterObj?.status}
                name="status"
                onChange={(e) => {
                  setFilterObj((prev) => ({
                    ...prev,
                    status: e.target.value,
                  }));
                }}
                
              >
                {statusOptions?.map((obj) => (
                  <MenuItem className="menuSm" key={obj} value={obj}>
                    {obj}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={9} md={12} lg={3.5} container justifyContent="flex-end">
            <Box display="flex" flexWrap="wrap" gap={1}>
              <Button
                variant="contained"
                size="small"
                onClick={() => fonLoad()}
              >
                Load
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  dispatch(
                    Head_Set({
                      A_TransId: 0,
                      A_Date: moment(),
                      A_Loc: vRdxuserLoc?.[0]?.Uid,
                      Loc_Name: "",
                      A_Narration: "",
                      A_Status: "ENTER",
                      CreatedBy: "",
                      CreatedDate: "",
                      ApproveStatus: "ENTER",
                      ApprovedBy: "",
                      ApproveDt: "",
                      A_LocCSV: vRdxuserLoc?.map((item) => item.Uid),
                      LoccsvName: "",
                      A_Status_CM: "",
                      A_Status_PM: "",
                    })
                  );
                  navigate("/RSPChangeRequestDetail");
                }}
              >
                New
              </Button>       
             <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
            </Box>
          </Grid>
        </Grid>
        <Box
          sx={{
          height: {xs: "75vh",   
        sm: "70vh",
        md: "72vh",   
        lg: "78vh",    },
          marginTop: "16px",
        }}
          className="search-grid-table mt-2"
        >
          <DataGridPro
            rowHeight={30}
            headerHeight={40}
            apiRef={apiRef}
            rows={row}
            getRowId={(v) => v.A_TransId}
            columns={[
              {
                field: "A_TransId",
                headerName: "Trans No",
                width: 70,
                align: "center",
              },
              {
                field: "A_Date",
                headerName: "Date",
                width: 88,
                align: "center",
                headerAlign:"center",
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },

              {
                field: "Loc_Name",
                headerName: "Trans Location",
                filterOperators: [
                  createMultiSelectOperator(multiSelectMUIlocation),
                ],

                width: 90,
              },
              {
                field: "LoccsvName",
                headerName: "Loc",
                width: 150,
              },
              {
                field: "A_Narration",
                headerName: "Narration",
                width: 200,
              },
              {
                field: "A_Status",
                headerName: "Status",
                width: 75,
                renderCell: (params) => {
                  const style = getStatusStyleV1(params.value);
                  return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },
              {
                field: "A_StatusCM",
                headerName: "CM Status",
                width: 80,
                renderCell: (params) => {
                  const style = getStatusStyleV1(params.value);
                  return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },
              {
                field: "A_StatusPM",
                headerName: "PM Status",
                width: 75,
              renderCell: (params) => {
                  const style = getStatusStyleV1(params.value);
                 return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },
              {
                field: "ApproveStatus",
                headerName: "Appr Status",
                width: 75,
              renderCell: (params) => {
                  const style = getStatusStyleV1(params.value);
                 return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },
              {
                field: "CreatedBy",
                headerName: "Created By",
                width: 100,
              },
              {
                field: "CreatedDate",
                headerName: "Created Date",
                width: 100,
                align: "center",
                headerAlign:"center",
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "A_CM_By",
                headerName: "Appr By CM",
                width: 110,
              },
              {
                field: "A_CM_Dt",
                headerName: "CMApprDate",
                width: 95,
                align: "center",
                headerAlign:"center",
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "A_PM_By",
                headerName: "Appr By PM",
                width: 110,
              },
              {
                field: "A_PM_Dt",
                headerName: "PM Appr Date",
                width: 95,
                align: "center",
                headerAlign:"center",
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "ApprovedBy",
                headerName: "Confirm By",
                width: 100,
              },
              {
                field: "ApproveDt",
                headerName: "Confirm Date",
                width: 95,
                align: "center",
                headerAlign:"center",
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
            ]}
            hideFooter={true}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
            onRowDoubleClick={(params) => handleRowClick(params)}
          />
        </Box>
    </>
  );
}
